import { isPositionModelWithLatLng, PositionModel } from '@cas/types/assets';
import { LatLng, latLngBounds } from 'leaflet';
import { useMemo } from 'react';
import useMapProvider from '../hooks/useMapProvider';
import { MapViewProps } from '@cas/components/maps/map-view/MapView';

export const usePositionsOnMap = (
  positionModels: Array<PositionModel | null | undefined>,
): MapViewProps => {
  const mapProvider = useMapProvider();

  return useMemo(() => {
    const points = positionModels
      .filter(isPositionModelWithLatLng)
      .map(pos => new LatLng(pos.lat, pos.lon));

    if (points.length > 1) {
      return { useMapProvider: () => mapProvider, bounds: latLngBounds(points) };
    }
    if (points.length === 1) {
      return { useMapProvider: () => mapProvider, initialCentre: points[0] };
    }
    return { useMapProvider: () => mapProvider };
  }, [positionModels, mapProvider]);
};

export default usePositionsOnMap;
